import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6deb3350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-1 flex-col" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1))
const _hoisted_4 = { class: "flex flex-1 mt-6" }
const _hoisted_5 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["title"]

import API, {
  IPostMachineWorkOrderTaskGetCurrMachineWorkOrderListBo,
  IPostMachineWorkOrderTaskGetCurrMachineWorkOrderListVo
} from "@/api/workOrder";
import JTable from "@/components/jtable/index.vue";
import { ITableData } from "@/components/jtable/tableType";
import JTabs, { ITagsData } from "@/components/jtabs-1/index.vue";
import JTag from "@/components/jtag/index.vue";
import { getStatusName, getStatusColor } from "@/constant/index";
import { SearchOutlined } from "@ant-design/icons-vue";
import { SelectProps } from "ant-design-vue";
import { onMounted, onUnmounted, reactive, ref } from "vue";
import { GetDateTimeLastStr, GetDateTimeZeroStr, getWekday, getMonthStar } from "@/constant";
import keyBorad from "@/components/keyborad/keyborad.vue";

//定义回调事件

export default /*#__PURE__*/_defineComponent({
  __name: 'Machine',
  emits: ["selectOrder"],
  setup(__props, { emit }: { emit: ({
  (e: "selectOrder", id: number): void;
}), expose: any, slots: any, attrs: any }) {




//定义生命周期事件
onMounted(() => {
  //生命周期处理内容
  getHomeTableData();
});

// ---------------------数据变量定义-------------------------
//数字键盘状态
let keyBoradShow = ref<boolean>(false);
//工单搜索条件
let selectKeys = reactive<IPostMachineWorkOrderTaskGetCurrMachineWorkOrderListBo>(
  cleanCondtion()
);

let tableList = ref<
  ITableData<IPostMachineWorkOrderTaskGetCurrMachineWorkOrderListVo>
>({
  total: 0,
  list: [],
});

let options = ref<SelectProps["options"]>([
  { value: "0", label: "全部" },
  { value: "wait_produced", label: "待生产" },
  { value: "producing", label: "生产中" },
  { value: "completed", label: "已完成" },
]);


let tagsTag: any = ref<ITagsData[]>([
  { name: "今日", value: "1" },
  { name: "昨日", value: "2" },
  { name: "本周", value: "3" },
  { name: "本月", value: "4" },
]);

// 表格
let tableConfig = {
  columns: [
    {
      title: "序号",
      key: "row",
      width: 120,
    },
    {
      title: "状态",
      dataIndex: "state",
      key: "state",
      width: 120,
      ellipsis: true,
    },

    {
      title: "工单单号",
      dataIndex: "workOrderCode",
      key: "workOrderCode",
      width: 270,
      ellipsis: true,
    },
    {
      title: "客户名称",
      dataIndex: "customerName",
      key: "customerName",
      width: 260,
      ellipsis: true,
    },
    {
      title: "产品名称",
      dataIndex: "productName",
      key: "productName",
      width: 200,
      ellipsis: true,
    },
    {
      title: "部件",
      dataIndex: "componentName",
      key: "componentName",
      width: 200,
      ellipsis: true,
    },
    {
      title: "工序名称",
      dataIndex: "processName",
      key: "processName",
      width: 200,
      ellipsis: true,
    },
    // {
    //   title: "前置工单",
    //   dataIndex: "relyOnWorkOrderCode",
    //   key: "relyOnWorkOrderCode",
    //   width: 180,
    //   ellipsis: true,
    // },
    {
      title: "来料",
      dataIndex: "preProcedureOutQty",
      key: "preProcedureOutQty",
      width: 180,
    },
    {
      title: "剩余产量",
      dataIndex: "remainingPlanOutput",
      key: "remainingPlanOutput",
      width: 180,
    },
    {
      title: "计划产量",
      dataIndex: "planOutput",
      key: "planOutput",
      width: 180,
    },
    {
      title: "计划生产时间",
      dataIndex: "planProductionTime",
      key: "planProductionTime",
      width: 300,
      ellipsis: true,
    },
    {
      title: "备注",
      dataIndex: "remarks",
      key: "remarks",
      width: 300,
      ellipsis: true,
    },
  ],
};

// ---------------------方法定义-------------------------
const openKeyboard = () => {
  selectKeys.workOrderCode = ''
  keyBoradShow.value = true
}
const putKeyBorad = (value) => {
  if (value == 'off') {
    keyBoradShow.value = false
    onSearch()
    return
  }
  selectKeys.workOrderCode = value || ''
  onSearch

}

//改变值
const handleChange = (value: string) => {
  onSearch();
};

//过滤数据
const filterOption = (input: string, option: any) => {
  return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

//获取首页列表数据
const getHomeTableData = () => {
  getTableData(1, 20);
};

const getTableData = (current: number, pageSize: number) => {
  selectKeys.pageNo = current;
  selectKeys.pageSize = pageSize;
  API.postMachineWorkOrderTaskGetCurrMachineWorkOrderList(selectKeys)
    .then((res: any) => {
      tableList.value.total = 0;
      tableList.value.list = [];
      if (res.list.length > 0) {
        tableList.value = res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

function cleanCondtion() {
  return {
    /**
     * 未说明
     */
    canBeReceived: true,
    /**
     * 页码
     */
    pageNo: 1,
    /**
     * 分页大小
     */
    pageSize: 30,
    /**
     * 生产状态,0:全部 wait_produced:待生产 incomplete:未完成 producing:生产中 completed:已完成
     */
    productionState: "wait_produced",
    /**
     * 工单编号，可以为空
     */
    workOrderCode: "",
    /**
     * 工单计划执 结束时间 yyyy-MM-dd HH:mm:ss
     */
    workOrderPlanEndTime: "",
    /**
     * 工单计划执 开始时间 yyyy-MM-dd HH:mm:ss
     */
    workOrderPlanStartTime: "",
  };
}

const onSearch = () => {
  getHomeTableData();
};

//切换日期
const switchData = (page: ITagsData) => {

  switch (page.value) {
    case "1":
      //今日
      selectKeys.workOrderPlanStartTime = GetDateTimeZeroStr(0);
      selectKeys.workOrderPlanEndTime = GetDateTimeLastStr(0);
      break;
    case "2":
      //昨日
      selectKeys.workOrderPlanStartTime = GetDateTimeZeroStr(-1);
      selectKeys.workOrderPlanEndTime = GetDateTimeLastStr(-1);
      break;
    case "3":
      //本周
      selectKeys.workOrderPlanStartTime = getWekday("s", 0);
      selectKeys.workOrderPlanEndTime = GetDateTimeLastStr(0);
      break;
    case "4":
      //本月
      selectKeys.workOrderPlanStartTime = getMonthStar();
      selectKeys.workOrderPlanEndTime = GetDateTimeLastStr(0);
      break;
    default:
      break;
  }
  onSearch();
}

const onSelectOrder = (item: IPostMachineWorkOrderTaskGetCurrMachineWorkOrderListVo) => {
  //查询订单
  emit("selectOrder", item.id)
};


return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_select, {
        value: _unref(selectKeys).productionState,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(selectKeys).productionState) = $event)),
        placeholder: "请选择状态",
        style: _normalizeStyle({ width: _ctx.$px2rem('180px'), }),
        options: _unref(options),
        "filter-option": filterOption,
        dropdownMenuStyle: { fontSize: _ctx.$px2rem('50px'), color: '#121212' },
        dropdownStyle: { fontSize: _ctx.$px2rem('50px'), color: '#121212' },
        size: "large",
        onChange: handleChange,
        dropdownMatchSelectWidth: _ctx.$px2rem(380)
      }, null, 8, ["value", "style", "options", "dropdownMenuStyle", "dropdownStyle", "dropdownMatchSelectWidth"]),
      _createVNode(JTabs, {
        "tags-data": _unref(tagsTag),
        class: "mx-4",
        canceTags: true,
        onSwitchTags: switchData
      }, null, 8, ["tags-data"]),
      _hoisted_3,
      _createVNode(_component_a_input, {
        class: "searchIpt",
        onClick: openKeyboard,
        value: _unref(selectKeys).workOrderCode,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(selectKeys).workOrderCode) = $event)),
        readonly: "",
        placeholder: "请输入工单编号",
        size: "large"
      }, null, 8, ["value"]),
      _createVNode(_component_a_button, {
        onClick: onSearch,
        class: "searchBtn"
      }, {
        icon: _withCtx(() => [
          _createVNode(_unref(SearchOutlined))
        ]),
        default: _withCtx(() => [
          _createTextVNode(" 搜索")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(JTable, {
        "cur-page": _unref(selectKeys).pageNo || 1,
        "page-size": 20,
        columns: _unref(tableConfig).columns,
        data: _unref(tableList),
        paginationPosition: "bottomRight",
        onUpdateData: getTableData
      }, {
        cell: _withCtx(({ column, index, record }) => [
          (column.key === 'row')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(index + 1), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'state')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "producStatu",
                  style: _normalizeStyle({
                background: _unref(getStatusColor)(record.state)
              })
                }, null, 4),
                _createTextVNode(" " + _toDisplayString(_unref(getStatusName)(record.state)), 1)
              ]))
            : _createCommentVNode("", true),
          (column.key === 'workOrderCode')
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "flex flex-row",
                onClick: ($event: any) => (onSelectOrder(record)),
                style: {"align-items":"center"}
              }, [
                _createElementVNode("a", {
                  class: "mr-4 flex-1 overflow-hidden",
                  title: record.workOrderCode,
                  style: _normalizeStyle({ width: _ctx.$px2rem('100px'), })
                }, _toDisplayString(record.workOrderCode), 13, _hoisted_7),
                (record.isUrgent === 'y')
                  ? (_openBlock(), _createBlock(JTag, {
                      key: 0,
                      class: "jtag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("急")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (record.state === 'completed' && record.goodOutput < record.planOutput)
                  ? (_openBlock(), _createBlock(JTag, {
                      key: 1,
                      class: "jtag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 缺 ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["cur-page", "columns", "data"])
    ]),
    (_unref(keyBoradShow))
      ? (_openBlock(), _createBlock(keyBorad, {
          key: 0,
          value: _unref(selectKeys).workOrderCode,
          onPutKeyBorad: putKeyBorad
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})